'use strict';
function throttle(n) {
    var r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 300, o = null;
    return function () {
        if (null === o) {
            for (var t = arguments.length, e = new Array(t), l = 0; l < t; l++)
                e[l] = arguments[l];
            n.apply(this, e), o = setTimeout(function () {
                o = null;
            }, r);
        }
    };
}
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = throttle;